module.exports = __webpack_public_path__ + "static/img/img_zhuanji.9727c8e.9727c8ea.jpg";